<h2 class="text-2xl font-bold">{{ '#RDP_LOG.SEARCH_PAGE.PAGE_TITLE' | translate }}</h2>

<!-- Date selection -->
<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <div class="flex flex-row">
    <div class="date-input">
      <label class="soft-label soft-label-top" for="from">{{ '#RDP_LOG.SEARCH_PAGE.INPUT_FROM' | translate }}</label>
      <soft-date-input id="from" formControlName="from"></soft-date-input>
    </div>
    <div class="date-input">
      <label class="soft-label soft-label-top" for="to">{{ '#RDP_LOG.SEARCH_PAGE.INPUT_TO' | translate }}</label>
      <soft-date-input id="to" formControlName="to"></soft-date-input>
    </div>
  </div>
  <div class="flex flex-row justify-end mt-4">
    <button class="soft-button soft-button-primary" type="submit">{{ '#RDP_LOG.SEARCH_PAGE.BTN_SEARCH' | translate }}</button>
  </div>
</form>
